export default __webpack_public_path__ + "static/media/1-3.7711f465.png";